<div class="h-full flex flex-col">
  <app-header></app-header>
  <div class="grow flex flex-col overflow-y-auto md:flex-row">
    <!-- Barra lateral. -->
    <aside
      class="flex flex-col gap-5 md:gap-10 border-b border-gray-200 min-w-80 min-h-60 overflow-y-auto px-6 py-5 md:py-10 md:border-e"
    >
      <!-- Sección de la cabecera. -->
      <section class="flex items-center pl-5">
        <span class="text-xl font-medium">Configuración</span>
      </section>

      <!-- Sección del menú. -->
      <section class="flex flex-col gap-4">
        @if (loading) {
        <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
        <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
        <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
        <div class="h-12 bg-gray-200 cursor-wait animate-pulse"></div>
        } @else {
        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Editar perfil"
          routerLink="/settings/profile"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>person</mat-icon>
          <span class="text-nowrap">Editar perfil</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Contraseña y seguridad"
          routerLink="/settings/password"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>shield</mat-icon>
          <span class="text-nowrap">Contraseña y seguridad</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Activaciones"
          routerLink="/settings/activation"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>key</mat-icon>
          <span>Activaciones</span>
        </button>

        @if (isAdminRole) {
        <!-- Acciones del menú para los administradores. -->
        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Empleados"
          routerLink="/settings/employee"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>manage_accounts</mat-icon>
          <span>Empleados</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Productos"
          routerLink="/settings/product"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>app_shortcut</mat-icon>
          <span>Productos</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Licencias"
          routerLink="/settings/license"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>workspace_premium</mat-icon>
          <span>Licencias</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Hosts"
          routerLink="/settings/host"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>dns</mat-icon>
          <span>Hosts</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="General"
          routerLink="/settings/general"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>settings</mat-icon>
          <span>General</span>
        </button>

        <button
          type="button"
          class="cursor-pointer flex items-center gap-3 rounded-full px-5 py-3 hover:bg-gray-200"
          aria-hidden="false"
          aria-label="Registros"
          routerLink="/settings/logs"
          routerLinkActive="!text-[#005cbb] !bg-[#e8f1fd]"
        >
          <mat-icon>event_note</mat-icon>
          <span>Registros</span>
        </button>
        } }
      </section>
    </aside>

    <div class="grow md:overflow-y-auto">
      <!-- Contenido. -->
      <main class="w-full px-5 md:px-20">
        <router-outlet></router-outlet>
      </main>

      <!-- Pie de página. -->
      <app-footer></app-footer>
    </div>
  </div>
</div>
